<template lang="pug">
.services-filter-bar
  b-taglist
    b-tag(
      v-for="(filter, $index) in filterList"
      :key="$index"
      size="is-medium"
      type="is-primary"
      closable
      rounded
      @close="close(filter)"
    )
      .tag-label
        cl-img(
          v-if="filter.img"
          :cl-id="filter.img"
          :transform="{ width: 48, height: 48, crop: 'thumb', quality: 'auto' }"
        )
        span {{ filter.label }}
    b-tag(
      v-if="filterList.length > 0"
      size="is-medium"
      type="is-light"
      closable
      rounded
      @close="clear"
    ) Clear All
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import * as getterTypes from '@/store/types/getters';
import * as mutationTypes from '@/store/types/mutations';

export default {
  name: 'services-filter-bar',
  computed: {
    ...mapGetters({
      filters: getterTypes.GET_SERVICES_FILTERS,
    }),
    filterList() {
      const list = [];
      const keys = _.keys(this.filters);
      const filteredKeys = _.filter(keys, k => k !== 'displayQuery');
      filteredKeys.forEach((key) => {
        const objects = this.filters[key];
        if (objects) {
          if (_.isArray(objects)) {
            objects.forEach((val) => {
              list.push(val);
            });
          } else {
            if (key === 'query' && this.filters.displayQuery) {
              list.push({ key, label: `"${objects}"` });
            } else if (key !== 'query') {
              list.push({ key, label: objects });
            }
          }
        }
      });
      return list;
    },
  },
  methods: {
    clear() {
      this.$store.commit(mutationTypes.SET_SERVICES_FILTER_DEFAULTS);
      this.$store.commit(mutationTypes.SET_SERVICES_REFRESH, true);
    },
    close(filter) {
      if (filter.key === 'query') {
        this.$store.commit(mutationTypes.SET_SERVICES_FILTER, {
          key: filter.key,
          val: null,
        });
        this.$store.commit(mutationTypes.SET_SERVICES_FILTER, {
          key: 'displayQuery',
          val: false,
        });
      } else {
        this.$store.commit(mutationTypes.TOGGLE_SERVICES_FILTER, {
          key: filter.key,
          val: filter,
        });
      }
      this.$store.commit(mutationTypes.SET_SERVICES_REFRESH, true);
    },
  },
};
</script>

<style lang="scss">
.services-filter-bar {
  padding: 0 1.5rem;
  .tag {
    .tag-label {
      display: flex;
      align-items: center;
      img {
        margin: 0 5px 0 -6px;
        height: 24px;
        width: 24px;
        border-radius: 100px;
      }
    }
  }
}
</style>

<style theme="cwo" lang="scss">
.services-filter-bar {
  .tag {
    &.is-light {
      background-color: #d8d8d8;
    }
  }
}
</style>
